import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectStateData } from 'src/core/redux/selectors';
import { addDetails } from 'src/actions';
import {
  REMAINDERS_NAMESPACE,
  REMAINDERS_NAMESPACE_ACTION,
  REMAINDER_VOLUME,
} from 'src/constants/forms';
import { DnaOligo } from 'src/models';
import { toDecimalValue } from 'src/utils';

import RemaindersComponent from './RemaindersComponent';

const RemainderContainer = ({
  formData,
  addFormData,
}) => {
  const onChangeData = (value, fieldName, isValid) => {
    addFormData({
      ...(formData || {}),
      [fieldName]: { value, isValid },
    });
  };

  const onBlurVolume = () => {
    // auto add value to decimals when bluring input
    const volumeData = formData?.[REMAINDER_VOLUME] || {};

    addFormData({
      [REMAINDER_VOLUME]: { ...volumeData, value: toDecimalValue(volumeData.value) },
    });
  };

  React.useEffect(() => {
    // add default state on mount. Override with existing state so when coming back to
    // this component (for exampe from plate pooling to normalization aliquots)
    // values will still persist
    const data = {
      ...DnaOligo.getDefaultRemaindersState(),
      ...(formData || {}),
    };

    addFormData({
      ...data,
      [REMAINDER_VOLUME]: {
        ...data[REMAINDER_VOLUME],
        // always convert value, when mounting, to decimal values
        value: toDecimalValue(data[REMAINDER_VOLUME]?.value)
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RemaindersComponent
      {...{
        formData,
        onChangeData,
        onBlurVolume,
      }}
    />
  );
};

RemainderContainer.propTypes = {
  formData: PropTypes.object,
  addFormData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  formData: selectStateData(REMAINDERS_NAMESPACE)(state),
});

const mapDispatchToProps = {
  addFormData: addDetails(REMAINDERS_NAMESPACE_ACTION),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemainderContainer);
